import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { catchError, Observable, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class FileUploadService {
    private baseUrl = environment.apiUrl + 'api/reports/';

    constructor(private http: HttpClient) {}

    upload(file: File): Observable<any> {
        const form = new FormData();
        form.append('file', file, file.name);
        const url = `${this.baseUrl}upload/${encodeURIComponent(file.name)}`;
        return this.http.post<any>(url, form).pipe(
            catchError((err :any) => {
                throwError(() => err);
                return throwError(() => err);
             })
         );
    }
}
